/* oddit-section-recommended-products — fill the grid from the Product Recommendations API */

(function () {
  var SECTION_SEL = '.oddit-section-recommended-products';
  var GRID_SEL = '.oddit-section-recommended-products__grid';
  var CARD_SEL = '.oddit-section-recommended-products__card';

  function initCarousel(root) {
    var track = root.querySelector(GRID_SEL);
    var progress = root.querySelector('[data-recommended-progress]');
    var bar = root.querySelector('[data-recommended-progress-bar]');
    var navs = root.querySelectorAll('[data-recommended-nav]');
    if (!track) return function () {};

    function sync() {
      var overflow = track.scrollWidth - track.clientWidth;
      var image = track.querySelector('.oddit-section-recommended-products__card-image-wrap');
      navs.forEach(function (nav) {
        var dir = Number(nav.dataset.recommendedNav);
        nav.hidden = overflow <= 1 || (dir < 0 ? track.scrollLeft <= 1 : track.scrollLeft >= overflow - 1);
        if (image) nav.style.top = image.offsetHeight / 2 + 'px';
      });

      if (!progress || !bar) return;
      if (overflow <= 1) {
        progress.hidden = true;
        return;
      }
      progress.hidden = false;
      var visible = track.clientWidth / track.scrollWidth;
      bar.style.width = visible * 100 + '%';
      bar.style.left = (track.scrollLeft / overflow) * (100 - visible * 100) + '%';
    }

    if (!root.dataset.carouselBound) {
      root.dataset.carouselBound = 'true';
      navs.forEach(function (nav) {
        nav.addEventListener('click', function () {
          var card = track.querySelector(CARD_SEL);
          var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          var step = card ? card.offsetWidth + gap : track.clientWidth;
          track.scrollBy({ left: step * Number(nav.dataset.recommendedNav), behavior: 'smooth' });
        });
      });
      track.addEventListener('scroll', sync, { passive: true });
      if (window.ResizeObserver) new ResizeObserver(sync).observe(track);
    }

    sync();
    return sync;
  }

  function normalize(value) {
    return (value || '').toLowerCase().trim();
  }

  function valueList(value, separator) {
    return normalize(value).split(separator || '|').map(function (v) { return v.trim(); }).filter(Boolean);
  }

  function sharesValue(a, b) {
    return a.some(function (v) { return b.indexOf(v) !== -1; });
  }

  function similarity(a, b) {
    if (!a.length || !b.length) return 0;
    var shared = a.filter(function (v, i) { return a.indexOf(v) === i && b.indexOf(v) !== -1; }).length;
    var union = a.concat(b).filter(function (v, i, all) { return all.indexOf(v) === i; }).length;
    return shared / union;
  }

  function fetchCards(url) {
    return fetch(url)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var next = new DOMParser().parseFromString(html, 'text/html').querySelector(GRID_SEL);
        return next ? Array.prototype.slice.call(next.querySelectorAll(CARD_SEL)) : [];
      })
      .catch(function () { return []; });
  }

  function pickCards(root, grid, cards, slots) {
    var matchType = normalize(root.dataset.matchType);
    var colorSeparator = /\||&|,|\band\b/;
    var matchColor = valueList(root.dataset.matchColor, colorSeparator);
    var matchStyle = valueList(root.dataset.matchStyle);
    var strict = root.dataset.matchStrict === 'true';

    var seen = {};
    seen[root.dataset.productId] = true;
    var existing = grid.querySelectorAll(CARD_SEL);
    for (var i = 0; i < existing.length; i++) {
      if (existing[i].dataset.productId) seen[existing[i].dataset.productId] = true;
    }

    var scored = [];
    cards.forEach(function (card, index) {
      var id = card.dataset.productId;
      if (!id || seen[id]) return;
      if (card.hasAttribute('data-sold-out') || card.hasAttribute('data-group-listing')) return;
      seen[id] = true;

      if (matchType && normalize(card.dataset.matchType) !== matchType) return;

      var colorScore = similarity(matchColor, valueList(card.dataset.matchColor, colorSeparator));
      var colorMatch = colorScore > 0;
      var styleMatch = matchStyle.length > 0 && sharesValue(matchStyle, valueList(card.dataset.matchStyle));
      var exact = !((matchColor.length && !colorMatch) || (matchStyle.length && !styleMatch));

      scored.push({ card: card, index: index, exact: strict && exact ? 1 : 0, color: colorScore, style: styleMatch ? 1 : 0 });
    });

    scored.sort(function (a, b) {
      return b.color - a.color || b.style - a.style || b.exact - a.exact || a.index - b.index;
    });

    return scored.slice(0, slots).map(function (entry) { return entry.card; });
  }

  var skuMatchRequests = (window.odditSkuMatchRequests = window.odditSkuMatchRequests || {});

  function fetchSkuMatch(searchUrl, sku) {
    var url =
      searchUrl +
      '?q=' + encodeURIComponent('variants.sku:' + sku) +
      '&type=product' +
      '&options[prefix]=none' +
      '&section_id=oddit-section-sku-match';

    if (!skuMatchRequests[url]) {
      skuMatchRequests[url] = fetch(url)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); })
        .catch(function () {
          delete skuMatchRequests[url];
          return null;
        });
    }
    return skuMatchRequests[url];
  }

  function skuMatchCards(doc, currentProductId, listKey) {
    if (!doc) return [];
    var matches = Array.prototype.slice.call(doc.querySelectorAll('[data-sku-match-product]')).filter(function (el) {
      return el.dataset.skuMatchProduct !== String(currentProductId);
    });
    matches.sort(function (a, b) {
      return (a.dataset.skuMatchGroup === 'true') - (b.dataset.skuMatchGroup === 'true');
    });
    for (var i = 0; i < matches.length; i++) {
      var list = matches[i].querySelector('[data-sku-match-list="' + listKey + '"]');
      if (list && list.children.length) {
        return Array.prototype.slice.call(list.children).filter(function (card) {
          return !card.hasAttribute('data-sold-out');
        });
      }
    }
    return [];
  }

  function resolveSkuMatch(root, grid) {
    root.dataset.skuMatchDone = 'true';

    fetchSkuMatch(root.dataset.searchUrl, root.dataset.skuMatch).then(function (doc) {
      if (!root.isConnected) return;
      var cards = skuMatchCards(doc, root.dataset.productId, 'you_may_also_like').slice(0, 10);

      if (cards.length) {
        grid.innerHTML = '';
        cards.forEach(function (card) {
          var added = document.importNode(card, true);
          if (root.dataset.revealNow === 'true') added.classList.add('is-visible');
          grid.appendChild(added);
        });

        var total = parseInt(root.dataset.recommendationsTotal, 10) || 4;
        var remaining = root.dataset.manualFill === 'true' ? Math.max(total - cards.length, 0) : 0;
        root.dataset.manualCount = String(cards.length);
        root.dataset.recommendationsSlots = String(remaining);
        root.dataset.recommendationsFetch = remaining > 0 ? 'true' : 'false';
      }

      root.hidden = false;
      init(root);
      if (cards.length) grid.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
    });
  }

  var variantRequests = {};

  function refreshForVariant(root, variantId) {
    if (!root.dataset.productUrl || !root.id) return;
    variantRequests[root.id] = variantId;

    var url =
      root.dataset.productUrl +
      '?variant=' + encodeURIComponent(variantId) +
      '&section_id=' + encodeURIComponent(root.id);

    fetch(url)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html || variantRequests[root.id] !== variantId) return;
        var next = new DOMParser().parseFromString(html, 'text/html').getElementById(root.id);
        var current = document.getElementById(root.id);
        if (!next || !current) return;

        var fresh = document.importNode(next, true);
        fresh.dataset.revealNow = 'true';
        fresh.querySelectorAll('.oddit-reveal').forEach(function (el) {
          el.classList.add('is-visible');
        });
        current.replaceWith(fresh);
        init(fresh);
        fresh.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
      })
      .catch(function () {});
  }

  // The recommendations object is only populated when the section is requested through
  // the Product Recommendations API, so the grid ships empty and is filled from a
  // second render of this same section.
  function init(root) {
    if (!root || !root.dataset.url || !root.dataset.productId) return;
    if (root.dataset.recommendationsFetched === 'true') return;

    var grid = root.querySelector(GRID_SEL);
    if (!grid) return;

    if (root.dataset.skuMatch && root.dataset.skuMatchDone !== 'true' && root.dataset.searchUrl) {
      resolveSkuMatch(root, grid);
      return;
    }

    var syncCarousel = initCarousel(root);

    if (root.dataset.recommendationsFetch === 'false') {
      if (!grid.children.length) root.hidden = true;
      return;
    }

    var manualCount = parseInt(root.dataset.manualCount, 10) || 0;
    if (grid.children.length && !manualCount) return;

    var slots = parseInt(root.dataset.recommendationsSlots, 10);
    if (!(slots > 0)) slots = parseInt(root.dataset.recommendationsLimit, 10) || 4;

    root.dataset.recommendationsFetched = 'true';

    var urls = [
      root.dataset.url +
        '?section_id=' + encodeURIComponent(root.id) +
        '&product_id=' + encodeURIComponent(root.dataset.productId) +
        '&limit=' + encodeURIComponent(root.dataset.recommendationsLimit) +
        '&intent=' + encodeURIComponent(root.dataset.recommendationsIntent)
    ];

    if (root.dataset.matchType && root.dataset.searchUrl) {
      urls.push(
        root.dataset.searchUrl +
          '?q=' + encodeURIComponent('product_type:"' + root.dataset.matchType + '"') +
          '&type=product' +
          '&options[prefix]=none' +
          '&section_id=oddit-section-recommended-products'
      );

      valueList(root.dataset.matchColor, /\||&|,|\band\b/).slice(0, 3).forEach(function (color) {
        urls.push(
          root.dataset.searchUrl +
            '?q=' + encodeURIComponent('product_type:"' + root.dataset.matchType + '" ' + color) +
            '&type=product' +
            '&options[prefix]=none' +
            '&section_id=oddit-section-recommended-products'
        );
      });
    }

    Promise.all(urls.map(fetchCards))
      .then(function (lists) {
        var incoming = pickCards(root, grid, [].concat.apply([], lists), slots);

        // No recommendations for this product: a lone heading over an empty row is
        // worse than no section at all.
        if (!incoming.length) {
          if (!grid.children.length) root.hidden = true;
          return;
        }

        incoming.forEach(function (card) {
          var added = document.importNode(card, true);
          if (root.dataset.revealNow === 'true') added.classList.add('is-visible');
          grid.appendChild(added);
        });

        if (!grid.children.length) {
          root.hidden = true;
          return;
        }

        syncCarousel();

        // Re-arms the reveal/stagger bindings the interactions script attaches to
        // replaced markup; it listens for this on document.
        grid.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
      })
      .catch(function () {});
  }

  document.querySelectorAll(SECTION_SEL).forEach(init);

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector && e.target.querySelector(SECTION_SEL);
    if (s) init(s);
  });

  document.addEventListener('oddit:variant-change', function (e) {
    var variantId = e.detail && e.detail.variantId;
    if (!variantId) return;
    document.querySelectorAll(SECTION_SEL).forEach(function (root) {
      refreshForVariant(root, String(variantId));
    });
  });
})();
